import { z } from 'zod';
import words from 'lodash/words.js';
import { InvalidArgumentError } from '@commander-js/extra-typings';

const reservedWords = new Set(['wix']);

const wordList = [...reservedWords].map((_) => `"${_}"`).join(', ');
const errorMessage = `The application name must be between 1 and 30 characters long and cannot include words like ${wordList}.`;

const schema = z
  .string()
  .min(1)
  .max(30)
  .refine((value) => {
    // Using `words` helper function, cause `wix` might be a valid part for words like `Wixology`, `Wixy`.
    return words(value).every(
      (word) => !reservedWords.has(word.toLocaleLowerCase())
    );
  });

export function validateAppNameSafe(value: string) {
  const result = schema.safeParse(value);
  if (result.success) {
    return true;
  }
  return errorMessage;
}

export function validateAppName(value: string) {
  const result = validateAppNameSafe(value);
  if (result === true) {
    return value;
  }
  throw new InvalidArgumentError(result);
}
